import { Button, Col, Modal, Popconfirm, Row } from 'antd'
import { DocumentApi } from '../../../../api/Document'
import RefreshButton from '../../../../elements/Buttons/RefreshButton'
import CustomSpin from '../../../../elements/CustomSpin'
import useFetchList from '../../../../elements/Hooks/useFetchList'
import useModalShow from '../../../../elements/Hooks/useModalShow'
import useSubmit from '../../../../elements/Hooks/useSubmit'
import IconText from '../../../../elements/IconText'
import Auth from '../../../../modules/Authentication'
import React from 'react'

import { streamUrl } from '../../../../variables'

const auth = new Auth()

const DocRow = (props) => {
  const { _id, label, owner, type, revision, code, regenerate, generate, fetch } = props
  console.log({ _id, owner })
  return (
    <div style={{ fontSize: '18px', marginBottom: '50px', fontWeight: 'bold' }}>
      <Col span={6}>{label}:</Col>
      <Col span={6} style={{ fontWeight: 'normal' }}>
        {_id ? `${code}.${revision}` : 'New'}
      </Col>
      <Col span={6}>
        <a
          target={'_blank'}
          // disabled={!_id}
          href={`${streamUrl}pdf/${owner}/${type}?access_token=${auth.getAccessToken()}`}>
          <IconText text={'PDF preview'} type={'file-pdf'} />
        </a>
      </Col>

      <Col span={6}>
        <Popconfirm
          title="This will generate New PDF document with it's own revision code?"
          onConfirm={() => {
            _id ? regenerate({ _id }) : generate({ type, owner })
            fetch()
          }}
          onCancel={fetch}
          okText="Yes"
          cancelText="No">
          <a>
            <IconText text={_id ? 'Regenerate PDF' : 'Generate New PDF'} type={'file-pdf'} />
          </a>
        </Popconfirm>
      </Col>
    </div>
  )
}

function GenerateDocument(props) {
  const { owner, isUpdatable } = props

  const { visible, onShow, onCancel } = useModalShow()
  const [regenerating, regenerate] = useSubmit(DocumentApi.regenerate)
  const [generating, generate] = useSubmit(DocumentApi.generate)
  const { list, fetching, fetch } = useFetchList(() => DocumentApi.list('*', `owner=${owner}`))

  return (
    <>
      <Modal visible={visible} title={'Documents'} onCancel={onCancel} destroyOnClose={true} width={'75%'}>
        <Row>
          <RefreshButton onClick={fetch} />
          <CustomSpin spinning={fetching || regenerating || generating}>
            <Col offset={2} span={22}>
              {list.map((doc) => (
                <DocRow {...{ owner, ...doc, regenerate, generate, fetch }} />
              ))}
            </Col>
          </CustomSpin>
        </Row>
      </Modal>
      <Button type={'primary'} size="small" icon={'plus'} disabled={!isUpdatable} onClick={onShow}>
        Manage Documents
      </Button>
    </>
  )
}

GenerateDocument.defaultProps = { isUpdatable: true }
export default (GenerateDocument)
